// Styles here will override Bulma styles
import styled from '@emotion/styled';
import media from 'css-in-js-media';
import Element from '../../element';

// BRAND LOGO STYLES

export const LogoContainer = styled(Element)`
  padding-top: 7px;
  z-index: 20;
  padding-left: 30px;

  img {
    height: 29px;
    max-height: 29px;
    width: 172px;

    ${media('<desktop')} {
      margin-top: 5px;
      margin-bottom: 10px;
    }
  }

  div {
    width: 100%;
    height: 30px;
  }

  ${media('<desktop')} {
    padding-left: 15px;
    padding-top: 15px;
  }
`;
